import { keepPreviousData, useQueries } from "@tanstack/react-query";
import { useAuth } from "../context/AuthContext";
import useApiV2, {
  CINCO_MINUTOS,
  repetirSoErroDeServidor,
} from "../utils/useApiV2";

// SKUs de cada categoria aberta na tabela agrupada. `abertas` é
// { [chaveDaCategoria]: quantosCarregar }; "mostrar mais" só aumenta o limite.
export default function useEventSkusPorCategoria({
  eventId,
  period,
  baseline = null,
  janela = null,
  status = null,
  busca = null,
  ordenarPor = null,
  ordem = "desc",
  abertas = {},
  enabled = true,
}) {
  const { getEventSkus } = useApiV2();
  const { user } = useAuth();
  const branchId = user?.active_branch_id ?? null;
  const termo = busca?.trim() || null;
  const entradas = Object.entries(abertas);

  const resultados = useQueries({
    queries: entradas.map(([categoria, limite]) => ({
      queryKey: [
        "eventSkusPorCategoria",
        user?.user_id ?? null,
        branchId,
        eventId,
        period,
        baseline,
        janela,
        status,
        termo,
        ordenarPor,
        ordem,
        categoria,
        limite,
      ],
      queryFn: () =>
        getEventSkus(eventId, {
          period,
          limit: limite,
          offset: 0,
          categoria,
          ...(baseline ? { baseline } : {}),
          ...(janela ? { janela } : {}),
          ...(status ? { status } : {}),
          ...(termo ? { q: termo } : {}),
          ...(ordenarPor ? { ordenar_por: ordenarPor, ordem } : {}),
        }),
      enabled: enabled && !!branchId && !!eventId,
      staleTime: CINCO_MINUTOS,
      retry: repetirSoErroDeServidor,
      placeholderData: keepPreviousData,
    })),
  });

  return Object.fromEntries(
    entradas.map(([categoria], indice) => {
      const resultado = resultados[indice];
      return [
        categoria,
        {
          skus: resultado?.data?.skus ?? [],
          total: resultado?.data?.meta?.total ?? 0,
          carregando: !!resultado?.isLoading,
          erro: !!resultado?.isError,
        },
      ];
    })
  );
}
